export default __webpack_public_path__ + "static/media/RDM_04.d8c84330.png";